import { render } from "./ApostillePricing.vue?vue&type=template&id=50f5ae6e"
import script from "./ApostillePricing.vue?vue&type=script&lang=js"
export * from "./ApostillePricing.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ContentCreator/Functional/ApostillePricing.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "50f5ae6e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('50f5ae6e', __exports__)) {
    api.reload('50f5ae6e', __exports__)
  }
  
  module.hot.accept("./ApostillePricing.vue?vue&type=template&id=50f5ae6e", () => {
    api.rerender('50f5ae6e', render)
  })

}


export default __exports__